import React, { createContext, useContext, useMemo, useState } from 'react'

const MakeChangesContext = createContext(null)

export const MakeChangesProvider = ({ children }) => {
  const [percentContribLimitExceededKey, setPercentContribLimitExceededKey] = useState({})
  const [percentContribLimit, setPercentContribLimit] = useState(null)

  const setPercentContribLimitExceeded = (key, value) => {
    if (!key) return

    const shouldError = Boolean(value)

    setPercentContribLimitExceededKey(previousFlags => {
      const currentValue = previousFlags[key]
      if (currentValue === shouldError) return previousFlags

      return { ...previousFlags, [key]: shouldError }
    })
  }

  const clearPercentContribLimitExceeded = key => {
    if (!key) return

    setPercentContribLimitExceededKey(previousFlags => {
      if (!Object.prototype.hasOwnProperty.call(previousFlags, key)) return previousFlags

      const nextFlags = { ...previousFlags }
      delete nextFlags[key]
      return nextFlags
    })
  }

  const displayPercentContribLimitExceeded = useMemo(() => {
    for (const key of Object.keys(percentContribLimitExceededKey)) {
      if (percentContribLimitExceededKey[key]) return true
    }
    return false
  }, [percentContribLimitExceededKey])

  const value = useMemo(
    () => ({
      percentContribLimit,
      displayPercentContribLimitExceeded,
      setPercentContribLimit,
      setPercentContribLimitExceeded,
      clearPercentContribLimitExceeded,
    }),
    [percentContribLimit, displayPercentContribLimitExceeded]
  )

  return <MakeChangesContext.Provider value={value}>{children}</MakeChangesContext.Provider>
}

export const useMakeChangesContext = () => {
  const context = useContext(MakeChangesContext)
  return context || {}
}

export default MakeChangesContext
